/**
 *  Colors
 */
var primaryNormal = '#0A26EE';
var primaryDark = '#000AB8';
var primaryLight = '#3D47F5';
var primaryUltraLight = '#EDF1F7';
var secondary = '#0D164E';
var secondaryDark = '#070C25';
var secondaryLight = '#404C90';
var secondaryUltraLight = '#EDEEF6';
var tertiary = '#00DCD4';
var tertiaryDark = '#00CBC4';
var tertiaryLight = '#3DE5DF';
var tertiaryUltraLight = '#D4F9F8';
var extra = '#7000C8';
var extraDark = '#6700B8';
var extraLight = '#8E3DF5';
var extraUltraLight = '#f7f1ff';
var success = '#07862B';
var info = '#259DD5';
var warning = '#FAB006';
var danger = '#EC0000';
var successUltralLight = '#F0F8F2';
var infoUltralLight = '#F2F9FC';
var warningUltralLight = '#FFFAF0';
var dangerUltraLight = '#FEF2F2';
var greyScale100 = '#000018';
var greyScale84 = '#29293D';
var greyScale72 = '#474759';
var greyScale60 = '#666474';
var greyScale48 = '#858590';
var greyScale36 = '#A3A3AC';
var greyScale24 = '#C2C2C8';
var greyScale16 = '#D6D6DA';
var greyScale8 = '#EBEBED';
var greyScale4 = '#F5F5F6';
var greyScale0 = '#FFFFFF';
/**
 * Background color for '<body>'.
 */

var bodyBg = primaryUltraLight;
/**
 * Background color for '<html>'.
 */

var htmlBg = 'transparent';
/**
 * Global text color on '<body>'.
 */

var textColor = '#212121';
var colors = {
  primary: {
    normal: primaryNormal,
    lighten: primaryLight,
    darken: primaryDark,
    ultraLighten: primaryUltraLight
  },
  secondary: {
    normal: secondary,
    lighten: secondaryLight,
    darken: secondaryDark,
    ultraLighten: secondaryUltraLight
  },
  tertiary: {
    normal: tertiary,
    lighten: tertiaryLight,
    darken: tertiaryDark,
    ultraLighten: tertiaryUltraLight
  },
  extra: {
    normal: extra,
    lighten: extraLight,
    darken: extraDark,
    ultraLighten: extraUltraLight
  },
  grey100: greyScale100,
  grey84: greyScale84,
  grey72: greyScale72,
  grey60: greyScale60,
  grey48: greyScale48,
  grey36: greyScale36,
  grey24: greyScale24,
  grey16: greyScale16,
  grey8: greyScale8,
  grey4: greyScale4,
  grey0: greyScale0,
  info: {
    normal: info,
    lighten: infoUltralLight
  },
  success: {
    normal: success,
    lighten: successUltralLight
  },
  warning: {
    normal: warning,
    lighten: warningUltralLight
  },
  danger: {
    normal: danger,
    lighten: dangerUltraLight
  },
  'body-bg': bodyBg,
  'html-bg': htmlBg,
  'text-color': textColor,
  'link-color': secondary
};
export default colors;